<template>
		<div class="card">
			<div class="card-body">
				<h5>
					<i class="far fa-plus-square"></i> Crea
					certificado
				</h5>
				<p class="card-title-desc">
					Has click aquí para crear un nuevo certificado.
				</p>
				<b-button block v-b-modal.add-certificado variant="success" @click="crearCertificado()" v-if="jsonCoordinadora.privilegios">
					<i class="fas fa-plus"></i>
					Agregar certificado
				</b-button>
				<PuSkeleton v-else :count="1"></PuSkeleton>
			</div>
				<ModalAddCertificado />
		</div>
	
</template>
<script>
import { mapState, mapActions } from "vuex";
import ModalAddCertificado from "@/components/certificado/modal/addCertificado";
export default {
	components: {
		ModalAddCertificado
	},
	data() {
		return {};
	},
	computed:{
		...mapState('alumno',['jsonCoordinadora']),
		...mapState('curso',['jsonCurso'])
	},
	methods: {
		...mapActions('curso',['updateActiveCurso']),
		crearCertificado(){
			
			const cursosPrivilegios = this.jsonCurso.map(c=>({
				...c,
				tituloCurso:  `#${c.idCurso} ${c.tituloCurso}`,
				estado:this.checkPrivilegio(c.idPrograma)
			}));

			const cursos = cursosPrivilegios.filter(cp=>cp.estado === true);
		
			this.updateActiveCurso(cursos);
		},
		checkPrivilegio(idPrograma) {
			// console.log(idPrograma);

			const dataCertificado = this.jsonCoordinadora.privilegios.find(
				(x) => x.idPrograma == idPrograma
			);
			return dataCertificado.certificado === 1 ? true : false;
		},
	}
};
</script>
